import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useStyles } from './styles'
import { TourContextType, TourProps } from './tour.typings'
import { TourContext } from './tourContext'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentStep, selectTourSteps } from '../../selectors/tour'
import TourStep from './tourStep/tourStep'
import { closeTour, gotoNextStep, gotoPreviousStep } from '../../reducer/tour.reducer'

const Tour: React.FC<TourProps> = ({ displayStyles }) => {
    const dispatch = useDispatch()
    const { classes, cx } = useStyles()
    const steps = useSelector(selectTourSteps)
    const currentStepNumber = useSelector(selectCurrentStep)
    const [tourContext, setTourContext] = useState<TourContextType>({
        height: window.innerHeight, width: window.innerWidth, devicePixelRatio, displayStyles: {
            backdropColor: '#000',
            backdropOpacity: 0.6,
            cornerRadius: 3,
            borderWidth: 0,
            borderColor: '',
            padding: 0,
            transitionDuration: 0.2,
            ...(displayStyles || {})
        }
    })

    const currentStep = useMemo(() => steps[currentStepNumber], [steps, currentStepNumber])

    const tourVisible = useMemo(() => steps.length > 0, [steps])

    const onWindowResize = useCallback(() => {
        setTourContext({
            width: window.innerWidth,
            height: window.innerHeight,
            devicePixelRatio,
            displayStyles: {
                backdropColor: '#000',
                backdropOpacity: 0.6,
                cornerRadius: 3,
                borderWidth: 0,
                borderColor: '',
                padding: 0,
                transitionDuration: 0.2,
                ...(displayStyles || {})
            }
        })
    }, [])

    const onKeyUp = useCallback((e: KeyboardEvent) => {
        if (e.code === 'Escape') {
            dispatch(closeTour())
        } else if (e.code === 'ArrowRight') {
            dispatch(gotoNextStep())
        } else if (e.code === 'ArrowLeft') {
            dispatch(gotoPreviousStep())
        }
    }, [dispatch])

    useEffect(() => {

        const disableMouseMove = (e: MouseEvent) => {
            e.stopPropagation()
        }
        if (tourVisible) {
            document.addEventListener('keyup', onKeyUp)

            window.addEventListener('mousemove', disableMouseMove, { capture: true })
        }

        return () => {
            window.removeEventListener('mousemove', disableMouseMove, { capture: true })
            document.removeEventListener('keyup', onKeyUp)
        }
    }, [tourVisible])

    useEffect(() => {
        window.addEventListener('resize', onWindowResize)
        return () => {
            window.removeEventListener('resize', onWindowResize)
        }
    }, [onWindowResize])

    return tourVisible ? (<div className={cx(classes.container, {})} id="tourContainer">
        <TourContext.Provider value={tourContext}>
            <TourStep {...currentStep} />
        </TourContext.Provider>
    </div>) : null
}

export default memo(Tour)